import Axios from 'axios'

const axios = Axios.create({
    baseURL: 'http://sividapi.progm.net.br/'
})

export default axios